const EnglishTranslation = {
  // GitterBadge
  GitterBadgeTitle: 'Join our community chat!'
}

export default EnglishTranslation
